import React, { useEffect } from "react";
import "./ScrollImg.css";

import m1 from "../../Assets/project11/m1.webp";
import m2 from "../../Assets/project11/m2.webp";
import m3 from "../../Assets/project11/m3.webp";
import m4 from "../../Assets/project11/m4.webp";
import m5 from "../../Assets/project11/m5.webp";
import m6 from "../../Assets/project11/m6.webp";
import m7 from "../../Assets/project11/m7.webp";
import m8 from "../../Assets/project11/m8.webp";
import m9 from "../../Assets/project11/m9.webp";
import m10 from "../../Assets/project11/m10.webp";
import m11 from "../../Assets/project11/m11.webp";
import m12 from "../../Assets/project11/m12.webp";
import m13 from "../../Assets/project11/m13.webp";
import m14 from "../../Assets/project11/m14.webp";
import m15 from "../../Assets/project11/m15.webp";
import m16 from "../../Assets/project11/m16.webp";


const ScrollImg11 = () => {
  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll(".section");
      const scroll = window.scrollY + window.innerHeight / 3;

      let isActiveSectionFound = false;

      sections.forEach((section) => {
        const top = section.offsetTop;
        const height = section.offsetHeight;

        if (top <= scroll && top + height > scroll) {
          sections.forEach((s) => s.classList.remove("active"));
          section.classList.add("active");
          isActiveSectionFound = true;
        }
      });

      // If no section is in view, ensure all are inactive
      if (!isActiveSectionFound) {
        sections.forEach((s) => s.classList.remove("active"));
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Trigger the scroll effect initially
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const images = [m1, m2, m3, m4, m5, m6, m7, m8, m9, m10, m11, m12, m13, m14, m15, m16];
  return (
    <div>
      {images.map((image, index) => (
        <div key={index} className="section">
          <div className="section-img">
            <div
              className="section-img-inner"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScrollImg11;
